import React, { FC, useEffect, useState } from "react";
import { validateCheckoutStep } from "./validate";
import { checkoutRoute } from "./route";
import { Step, validateFromTo } from "../stepsStore";
import { Tabs, Divider } from "../../components";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../config";
import { mainStep } from "../Main";
import CheckoutForm from "./Form";

export const checkoutStep: Step = {
  order: 2,
  tKey: "checkout",
  validate: validateCheckoutStep,
  route: checkoutRoute,
};

const tKeyStepCheckout = AppConfig.translationFileNames.step_Checkout;
const tKeyStepFf = AppConfig.translationFileNames.ff;

const MenuStep: FC = () => {
  const { t } = useTranslation([tKeyStepCheckout, tKeyStepFf]);
  const [type, setType] = useState<"individual" | "company">("individual");

  useEffect(() => {
    validateFromTo(mainStep.order, checkoutStep.order, true, false);
  }, []);

  return (
    <>
      <Tabs value={type} onChange={setType as any}>
        <Tabs.TabPane
          title={t("step_Checkout:types.individual")}
          name={"individual"}
        />
        <Tabs.TabPane
          title={t("step_Checkout:types.company")}
          name={"company"}
        />
      </Tabs>

      <Divider />

      <CheckoutForm type={type} />
    </>
  );
};

export default MenuStep;
